import React, { useState } from "react";

import { DeleteConfirmationModal } from "../../../../../../components/modals/delete-confirmation-modal/delete-confirmation-modal.component";
import { BriefHeader } from "../../../../../../features/brief-header/components/brief-header/brief-header.component";
import { getUserFullName } from "../../../../../../features/user/types/user.functions";
import { IUser } from "../../../../../../types/user/iuser.interface";
import { BasicResourceType } from "../../../../../../types/resources/resources.enums";

import * as flyerStore from "../../../../store/flyer.store";
import { FlyerDetailHeaderProps } from "./flyer-detail-header.props";

export const FlyerDetailHeader = (props: FlyerDetailHeaderProps) => {
  const [confirmModalOpen, setConfirmModalOpen] = useState<boolean>(false);

  const onConfirmDelete = () => {
    flyerStore.deleteFlyer(props.flyer!.id);
  };

  const toggleConfirmModalOpen = () => {
    setConfirmModalOpen(!confirmModalOpen);
  };

  const createExtraActions = () => {
    if (props.flyer!.completed) {
      return [
        {
          label: "Delete",
          action: () => toggleConfirmModalOpen(),
        },
      ];
    }
  };

  if (!props.flyer) {
    return null;
  }

  return (
    <>
      <BriefHeader
        briefId={props.flyer.id}
        briefName={props.flyer.name}
        briefOwner={getUserFullName(props.flyer.owner as IUser)}
        briefTemplate=""
        briefType={BasicResourceType.Flyer}
        currentTabValue={props.currentTabValue}
        extraActions={createExtraActions()}
        formRef={props.formRef}
        hasErrors={props.hasErrors}
        loaded={props.loaded}
        setHeaderHeight={props.setHeaderHeight}
        showIf={!!props.formRef}
        updatedTime={props.flyer.updatedAt}
        isSaveDisabled={!props.permissions || !props.permissions.canEdit}
        onChangeName={props.onChangeName}
        onSubmit={props.onSubmit}
      />
      <DeleteConfirmationModal
        isOpen={confirmModalOpen}
        description={props.flyer.name}
        onConfirm={onConfirmDelete}
        onCancel={toggleConfirmModalOpen}
      />
    </>
  );
};
